var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab",on:{"click":function($event){return _vm.goTo(_vm.scrollId)}}},[_c('img',{staticClass:"tab__img",attrs:{"src":_vm.imgUrl,"alt":""}}),_c('p',{staticClass:"tab__title",domProps:{"innerHTML":_vm._s(_vm.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }